exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label[for*=descriptionField],label[htmlfor*=descriptionField]{top:0;line-height:13px!important}", ""]);

// exports
